import { render, staticRenderFns } from "./chatMain.vue?vue&type=template&id=3163618d&scoped=true"
import script from "./chatMain.vue?vue&type=script&lang=js"
export * from "./chatMain.vue?vue&type=script&lang=js"
import style0 from "./chatMain.vue?vue&type=style&index=0&id=3163618d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163618d",
  null
  
)

export default component.exports